import { sendAdobeData } from './sendAdobeData';
import { sendDecibelData } from './sendDecibelData';

export const sendAnalytics = (digitalData = {}) => {
  if (window._DATADOG_SYNTHETICS_BROWSER) {
    return;
  }

  sendAdobeData(digitalData);
  sendDecibelData(digitalData);
};
